import React, { createContext, useContext, useState } from 'react';
import type { IconType, Props as IconProps } from '@rc/Icon';

export type BannerProps = {
  title: string;
  description: JSX.Element | string;
  iconProps?: {
    name: IconType;
  } & Omit<IconProps, 'name'>;
  cta?: string;
  onCtaClick?: () => unknown;
  className?: { container?: string; title?: string; description?: string; cta?: string };
};
type Value = BannerProps | null;
type Setter = React.Dispatch<React.SetStateAction<Value>>;

const BannerContext = createContext<[Value, Setter]>([null, () => null]);

export const BannerProvider = ({ children }: React.PropsWithChildren<unknown>): JSX.Element => {
  const value = useState<Value>(null);
  return <BannerContext.Provider value={value}>{children}</BannerContext.Provider>;
};

export const useBanner = (): [Value, Setter] => {
  return useContext(BannerContext);
};
